<ng-container *appTranslate="let t">
  <new-ui-candidate-list-multi-edit-inline
    [padded]="true"
    [listPath]="props.listPath"
    [candidateIds]="options.formState.multiEdit?.candidateIds"
    [candidateOrganizationId]="options.formState.organizationId"
    [sharedTabHash]="options.formState.multiEdit?.sharedTabHash"
    [readonly]="!!options.formState.readonly"
    [sectionLabel]="sectionLabel"
    [createElementForm]="createElementForm"
  >
    <ng-template let-form let-index="index" let-remove="remove">
      <p-card>
        <ng-template #title>
          <div class="flex items-center">
            @if (props.formatLabel) {
              <span>{{ formatLabel(form, index) }}</span>
            }

            @if (props.formatSublabel) {
              <span class="text-text-subtle-text ms-2">{{ formatSublabel(form, index) }}</span>
            }

            @if (!options.formState.readonly) {
              <div class="row ms-auto">
                <new-ui-button
                  icon="pi pi-trash"
                  variant="text"
                  severity="danger"
                  [label]="props.removeLabel"
                  [ariaLabel]="props.removeLabel ?? t('common.remove')"
                  (onClick)="remove()"
                />
              </div>
            }
          </div>
        </ng-template>

        <formly-form
          [form]="form"
          [fields]="rowFields(form)"
          [model]="rowModel(form)"
          [options]="rowOptions(form)"
        ></formly-form>
      </p-card>
    </ng-template>
  </new-ui-candidate-list-multi-edit-inline>
</ng-container>
